/**
 * ToggleSideCart Directive
 * Matches TypeScript toggle-side-cart.directive.ts exactly
 * Handles toggle button clicks for side cart and cart icon indicator
 */
// @ts-nocheck
import { SideCartManager } from '@theme/side-cart-manager';
import CartManager from '@theme/cart-manager';

class ToggleSideCart {
  static selector = '[toggle-side-cart]';

  constructor(hostElement) {
    this.host = hostElement;
    this.sideCartManager = SideCartManager.getInstance();
    this.iconIndicator = hostElement.querySelector('.quick-cart__icon-indicator');

    this.init();
  }

  init() {
    // Subscribe to status changes - matches TypeScript line 21
    this.unsubscribeStatus = this.sideCartManager.subscribe(this.onStatusChange.bind(this));

    // Bind click event - matches TypeScript line 40-44
    this.host.addEventListener('click', this.onHostClick.bind(this));

    // Listen to cart updates to show/hide icon indicator - matches TypeScript line 23-25, 47-53
    if (this.iconIndicator) {
      document.addEventListener('cart:update', this.onCartUpdate.bind(this));
      // Initial state
      this.updateIconIndicator();
    }
  }

  onStatusChange(status) {
    // Matches TypeScript line 32-38
    if (status === 'closed') {
      this.host.setAttribute('aria-expanded', 'false');
    } else {
      this.host.setAttribute('aria-expanded', 'true');
    }
  }

  onHostClick(e) {
    // Matches TypeScript line 41-44
    e.preventDefault();
    this.sideCartManager.toggle();
  }

  onCartUpdate(event) {
    // Matches TypeScript onCartChange - line 47-53
    this.updateIconIndicator();
  }

  updateIconIndicator() {
    let itemCount = 0;
    const cartCounterElements = document.querySelectorAll('[cart-counter]');

    if (cartCounterElements.length > 0) {
      const counterText = cartCounterElements[0].textContent.trim();
      itemCount = parseInt(counterText, 10) || 0;
    } else {
      const managerCart = CartManager.getInstance().getState();
      const bootstrapCart = managerCart || window.getBootstrapCart?.();
      if (bootstrapCart) {
        itemCount = window.getCartItemCount(bootstrapCart);
      } else {
        const cartCountEl = document.querySelector('[ref="cartItemCount"]');
        if (cartCountEl) {
          itemCount = parseInt(cartCountEl.textContent, 10) || 0;
        }
      }
    }

    // Show/hide indicator - matches TypeScript line 48-52
    if (itemCount === 0) {
      this.iconIndicator?.classList.add('hidden');
    } else {
      this.iconIndicator?.classList.remove('hidden');
    }
  }

  destroy() {
    if (this.unsubscribeStatus) {
      this.unsubscribeStatus();
    }
    this.host.removeEventListener('click', this.onHostClick);
    if (this.iconIndicator) {
      document.removeEventListener('cart:update', this.onCartUpdate);
    }
  }
}

// Initialize ToggleSideCart on DOM ready
function initToggleSideCart() {
  const toggleElements = document.querySelectorAll(ToggleSideCart.selector);
  toggleElements.forEach(element => {
    if (!element.toggleSideCartInstance) {
      element.toggleSideCartInstance = new ToggleSideCart(element);
    }
  });
}

// Initialize on DOM ready and section load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initToggleSideCart);
} else {
  initToggleSideCart();
}

// Re-initialize on section load (Shopify sections)
document.addEventListener('shopify:section:load', initToggleSideCart);

// Export for module usage
export default ToggleSideCart;

